var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 33.231,
    viewBox: "0 0 36 33.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-heart-empty",
    "data-name": "Icon ionic-md-heart-empty",
    d: "M29.475,4.5a10.648,10.648,0,0,0-8.1,3.8,10.648,10.648,0,0,0-8.1-3.8,9.787,9.787,0,0,0-9.9,9.961c0,6.88,6.118,12.4,15.387,20.916l2.613,2.354,2.613-2.354c9.268-8.515,15.387-14.037,15.387-20.916A9.787,9.787,0,0,0,29.475,4.5ZM22.483,33l-.363.338-.744.675-.744-.675L20.267,33A110,110,0,0,1,9.649,22.439c-2.423-3-3.5-5.461-3.5-7.979A7.2,7.2,0,0,1,8.2,9.329a7.043,7.043,0,0,1,5.071-2.06,7.937,7.937,0,0,1,5.98,2.812l2.12,2.518,2.12-2.518a7.907,7.907,0,0,1,5.98-2.812,7.077,7.077,0,0,1,5.08,2.06,7.213,7.213,0,0,1,2.051,5.132c0,2.51-1.082,4.976-3.5,7.979A110.218,110.218,0,0,1,22.483,33Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#527991"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.5d107bdd.svg";
export { ForwardRef as ReactComponent };